export enum EmailStatus {
  REGULAR = 1,
  WITHOUT_PASS = 2,
  OUTDATED_PASS = 3,
  NOT_FOUND = 4,
}
